// Copyright 2019, White Label Communications, LLC, All rights reserved.

import {
  FETCH_LOGOUT_SUCCESS,
} from 'actions/LoginActions';
import {
  COMP_DIR_PUT_START,
  COMP_DIR_PUT_SUCCESS,
  COMP_DIR_PUT_ERROR,
} from 'actions/CompanyDirectory';

const initialState = {
  status: 0, // 0=started request(init state), 1=loading/checking, 2=error, 3=comp directory post request completed
  error: '', // holds error mess when status=2
};

export default function (state = initialState, action) {
  switch (action.type) {
    case COMP_DIR_PUT_START:
      return {
        ...state,
        status: 1, // drives isLoading in UI
        error: '',
      };
    case COMP_DIR_PUT_ERROR:
      return {
        ...state,
        status: 2, // this status will turn off isLoading
        error: action.error, // store error in state, UI can use it if appropriate
      };
    case COMP_DIR_PUT_SUCCESS:
      return {
        ...state,
        status: 3,
        error: '',
      };
    case FETCH_LOGOUT_SUCCESS:
      return {
        ...state,
        status: 0, // 0 means logged out, also starting init state
        error: '',
      };
    default:
      return state;
  }
}
